(function() { window.GUID_699bc26a_2161_45b4_b989_17080e39682d = { getGuid: function() { return "699bc26a-2161-45b4-b989-17080e39682d"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class QuickTournamentsSection {
                        static get instance() {
                            if (!QuickTournamentsSection._instance)
                                QuickTournamentsSection._instance = new QuickTournamentsSection();
                            return QuickTournamentsSection._instance;
                        }
                        constructor() { }
                        static RemoveQuickTournament(quickTournamentId, $quickTournament) {
                            CS.Ajax.Post(CS.Url.CSUrl("deletequicktournament"), { quickTournamentId }, () => {
                                if ($quickTournament.length) {
                                    $quickTournament.slideUp();
                                }
                            });
                        }
                    }
                    WallSections.QuickTournamentsSection = QuickTournamentsSection;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=quick-tournaments-section.js.map
